<template>
    <ModalComponent
        name="partidosModal"
        title="Partidos del abono"
        @close="$emit('close')"
        @opened="getEventos()"
    >
        <template v-if="!entradaSeleccionada">
            <div v-if="loading" class="text-center py-4">
                <div class="spinner-border" role="status">
                </div>
                <p class="mt-2">{{$t('perfil_sga.cargando')}}</p>
            </div>
            <div v-else-if="entradas.length == 0" class="text-center py-4">
                <b-icon icon="calendar-x" style="font-size: 3rem;" class="text-muted mb-3"/>
                <p class="text-muted">{{$t('perfil_sga.no_eventos_cesion')}}</p>
            </div>
            <div class="row" v-else>
                <div class="col-12 mb-3" v-for="entrada in entradas" :key="entrada.id">
                    <b-card class="border shadow-sm">
                        <b-card-body class="p-3">
                            <div class="w-100 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                <div class="d-flex align-items-center p-2 mb-2 mb-md-0">
                                    <p class="mb-0 font-weight-bold">{{ entrada.event_object.name  }}</p>
                                </div>                            
                                <div class="d-flex align-items-center font-weight-normal">
                                    <b-icon icon="calendar"  />
                                    <p class="mb-0 px-3">{{ entrada.event_object.date }}</p>
                                </div>
                                <div class="p-2" v-if="entrada.beneficiary.profileId == perfil.id">
                                    <button class="btn btn-primary" @click="entradaSeleccionada = entrada;" v-if="entrada.status == 'Active'">
                                        Ceder entrada
                                    </button>
                                </div>
                            </div>
                            <hr/>
                            <div class="w-100 d-flex justify-content-center">
                                <h4>{{getStatusText(entrada.status)}}</h4>
                            </div>
                            <hr v-if="entrada.beneficiary.profileId != perfil.id && entrada.status == 'Active'"/>
                            <div class="w-100 d-flex justify-content-center" v-if="entrada.beneficiary.profileId != perfil.id && entrada.status == 'Active'">
                                <div class="w-100 d-flex justify-content-between d-md-block">
                                    <div class="w-auto d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center pr-0 pr-md-4">
                                        <div class=" w-auto d-flex flex-column flex-md-row align-items-start align-items-md-center">
                                            <div class="border d-none d-lg-flex align-items-center justify-content-center p-1 mr-3 rounded-circle overflow-hidden mb-2 mb-md-0" style="width: 50px; height: 50px;">
                                                <b-icon icon="person" class="w-100 h-100"/>
                                            </div>
                                            <div>
                                                <div class="d-flex mb-2">
                                                    <p class="mb-0 mr-2"> {{ entrada.beneficiary.profile.name }}</p>
                                                    <p class="mb-0"> {{ entrada.beneficiary.profile.lastName }} </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="d-flex font-weight-normal mb-2">
                                                <b-icon icon="card-text" class="mr-2" />
                                                <p class="mb-0"> {{ entrada.beneficiary.profile.identification.value }} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-card>
                </div>
            </div>
        </template>
        <template v-else>            
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <b-row>
                    <b-col cols="6">
                        <FormInput
                            v-model="nuevoAbono.name"
                            id="nombre"
                            rules="required"
                            :label="$t('formularios.nombre')"
                            :name="$t('formularios.nombre')"
                        />
                    </b-col>
                    <b-col cols="6">
                        <FormInput
                            v-model="nuevoAbono.lastName"
                            rules="required"
                            id="apellidos"
                            :label="$t('formularios.apellidos')"
                            :name="$t('formularios.apellidos')"
                        />
                    </b-col>
                    <b-col cols="6">
                        <DocumentoTipo
                            :value="nuevoAbono.identification.type"
                            :index="1"
                            @input="val => { nuevoAbono.identification.type = val; }"
                        />
                    </b-col>
                    <b-col cols="6">
                        <DocumentoValor
                            :type="nuevoAbono.identification.type"
                            :value="nuevoAbono.identification.value"
                            :index="1"
                            @input="val => { nuevoAbono.identification.value = val; }"
                        />
                    </b-col>
                    <b-col cols="6">
                        <FormInput
                            v-model="nuevoAbono.email"
                            rules="required"
                            vid="confirmation"
                            id="email"
                            type="email"
                            :label="$t('formularios.email')"
                            :name="$t('formularios.email')"
                        />
                    </b-col>
                    <b-col cols="6">
                        <FormInput
                            v-model="nuevoAbono.email_confirm"
                            id="email-confirm"
                            type="email"
                            rules="required|confirmed_ci:@confirmation"
                            :label="$t('formularios.confirmar_email')"
                            :name="$t('formularios.confirmar_email')"
                        />
                    </b-col>
                    <b-col cols="12">
                        <b-button type="submit">Transferir entrada</b-button>
                    </b-col>
                </b-row>
            </ValidationObserver>   
            
        </template>        
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";

    export default {
        name: "PartidosModal",
        props: {
            abono: {
                type: Object,
                required: true
            },
            perfil: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                entradas: null,
                entradaSeleccionada: null,
                nuevoAbono: {
                    name: '',
                    lastName: '',
                    identification: {
                        type: 'DNI',
                        value: ''
                    },
                    email: '',
                    email_confirm: '',
                },
                enviando: false
            };
        },
        methods: {
            getEventos() {                
                const params = {
                    abonado_id: this.abono.id
                };
    
                this.$store.dispatch(this.config.getVuexAlias("sga.profile.abono.entradas"), params).then(res => {
                    this.entradas = res.data.data;
                }).catch(error => {
                    this.$toast.error(this.$t('perfil_sga.error_carga_eventos'));
                    this.entradas = null;
                }).finally(() => {
                    this.loading = false;
                });
            },
            transferirEntrada() {
                this.loading = true;

                const params = {
                    filters : {},
                    profile_new: this.nuevoAbono,
                    abonado_id: this.abono.id,
                    sga_entitlement_id: this.entradaSeleccionada.id,
                    sga_event_id: this.entradaSeleccionada.event_object.id
                }

                this.$store.dispatch(this.config.getVuexAlias("front.perfil.abono.sga.transferir"), params).then(res => {
                    this.$toast.success(this.$t('perfil_sga.abono_transferido_correctamente'));
                }).catch(e => {
                    console.error(e);
                }).finally(() => {
                    this.getEventos();
                    this.entradaSeleccionada = null;
                });
            },
            async submit() {
                if (this.enviando) return;

                this.enviando = true;

                const observerRefs = this.$refs;
                let isValid = await this.$refs.observer.validate();

                if (isValid) {
                    this.transferirEntrada();
                }

                this.enviando = false;
            },
            getStatusText(status) {
                switch (status) {
                    case 'Active':
                        return 'Activo';
                    case 'CededSold':
                        return 'Asiento cedido y vendido';
                    case 'Ceded':
                        return 'Asiento cedido';
                    case 'CededSoldFinalized':
                        return 'Asiento cedido y vendido (finalizado)';
                    default:
                        return status;
                }
            }
        },
        components: {
            ModalComponent, DocumentoTipo, DocumentoValor
        }
    };
</script>